<template>
  <el-container v-loading="loading" id="top" style="height:969px;">
    <el-header>
      <HeaderView :userName="viewUserName" />
    </el-header>
    <el-container>
      <el-container id="submenu" style="height:100%;overflow:auto;">
        <el-aside>
          <MenuView :cowMenuRadio="cow_menu_radio" :isAdmin="isAdmin" :userType="userType" :farmerId="farmer_id" />
        </el-aside>
      </el-container>
      <el-container id="sub" style="height:100%;overflow:auto;">
        <el-main style="padding-top:20px;width:100%;">
          <div class="toggle-area" style="text-align: center;">
            <el-radio-group id="eventradio" fill="#ffdf5e" text-color="#000000" v-model="eventMenuRadio"
              @change="radioChange()">
              <el-radio-button label="一覧" />
              <el-radio-button label="グラフ" />
            </el-radio-group>
          </div>
          <el-row :gutter="20">
            <el-col :span="18">
              <el-row :gutter="20">
                <el-col :span="24">
                  <!-- <div v-if="eventMenuRadio !== 'グラフ'" style=" margin-top:12px;padding-left:20%;text-align:center;">
                    {{ cow_name }}</div> -->
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="6">
              <!-- <el-select v-if="eventMenuRadio !== 'グラフ' & !edit_alert" placeholder="" v-model="select_barn_id"
                @change="barnChange()" style="width:305px;padding-top:6px;">
                <el-option v-for="barnInfo in this.barnsInfoData" :key="barnInfo.id" :label="barnInfo.barn_name_sub"
                  :value="barnInfo.barn_id" />
              </el-select> -->
              <el-select v-if="eventMenuRadio !== 'グラフ'" placeholder="" v-model="select_barn_id" :disabled="edit_alert"
                @change="barnChange()" style="width:305px;padding-top:6px;">
                <el-option v-for="barnInfo in this.barnsInfoData" :key="barnInfo.id" :label="barnInfo.barn_name_sub"
                  :value="barnInfo.barn_id" />
              </el-select>
            </el-col>
          </el-row>
          <!-- レポート -->
          <el-row v-if="eventMenuRadio === 'グラフ'" :gutter="20" style="margin-top:1em;">
            <el-col :span="8"><span style="font-size:small;">{{ report_view_date }}</span></el-col>
          </el-row>
          <el-row v-if="eventMenuRadio === 'グラフ'" style="justify-content:left;width:100%">
            <el-col :span="19" style="min-width:1240px;">
              <div v-show="!loading && (targetReportDates.length != 0)"
                style="width:1240px; height:430px; overflow-x:auto; overflow-y:hidden;">
                <canvas ref="canvas" :style="`width: ${canvas_size}px; height: 400px;`"></canvas>
              </div>
              <div v-if="!loading && (targetReportDates.length == 0)">
                <el-row class="width100">
                  <el-row class="width100" style="justify-content:center;margin-top:10%;">
                    <p class="font_18 font_bold">現在グラフ情報はありません</p>
                  </el-row>
                  <el-row class="width100" style="justify-content:center;">
                    <img src="@/assets/ImgIllustAlertEmpty.png" />
                  </el-row>
                </el-row>
              </div>
            </el-col>
            <el-col :span="3" style="min-width:200px;">
              <el-row>
                <el-select placeholder="" v-model="select_barn_id" @change="barnChange()" style="width:200px">
                  <el-option v-for="barnInfo in this.barnsInfoData" :key="barnInfo.id" :label="barnInfo.barn_name_sub"
                    :value="barnInfo.barn_id" />
                </el-select>
              </el-row>
              <!-- 牛選択 start -->
              <el-row v-if="reportInfo.length > 1" style="margin-top:25px;">
                <el-select placeholder="" v-model="select_cow_track_id" @change="cowChange()" style="width:200px">
                  <el-option v-for=" rInfo  in  this.reportInfo " :key="rInfo.cow_track_id" :label="rInfo.cow_name"
                    :value="rInfo.cow_track_id" />
                </el-select>
              </el-row>
              <!-- 牛選択 end -->
              <el-row style="margin-top:70px;">
                <el-select id="select_days" placeholder="" v-model="report_days" style="width:200px"
                  @change="daysChange()">
                  <el-option v-for=" select_day  in  this.select_days " :key="select_day.id" :label="select_day.day"
                    :value="select_day.day" />
                </el-select>
              </el-row>
              <el-row style="margin-top:25px;">
                <v-date-picker ref="reportCalendar" v-model="report_target_date" is-required :min-date="reportMinDate"
                  :max-date="new Date()" :disabled-dates="reportDates" @change="dateChange()" @dayclick="dateChange()" />
              </el-row>
            </el-col>
          </el-row>
          <!-- アラート -->
          <el-row :gutter="20" v-if="eventMenuRadio === '一覧' & !edit_alert" style="justify-content:left;">
            <el-col :span="18">
              <el-button v-if="eventMenuRadio === '一覧' & alertsTable.length != 0 & !edit_alert" color="#EEEEEC"
                class="operation-btn" @click="editAlert()" :disabled="isUserTypeDisabled">
                <el-icon v-if="!isUserTypeDisabled" color="#383838" style="padding-right: 1em;">
                  <IconPencil />
                </el-icon>
                <el-icon v-if="isUserTypeDisabled" color="#E8E2C6" style="padding-right: 1em;">
                  <IconPencil />
                </el-icon>
                編集
              </el-button>
              <el-row :gutter="20" style="margin-top:1em;">
                <div style="padding-left:10px;"><span style="font-size:small;">{{ report_view_date }}</span></div>
              </el-row>
              <div v-loading="loadingImg" style="width:97%;height: 540px;">
                <div v-if="alertsTable.length != 0">
                  <el-table id="alertTable" class="event-table" :data="alertsTable"
                    :default-sort="{ prop: 'date_time', order: 'descending' }" height="540" :show-header="false"
                    :highlight-current-row="false" stripe>
                    <el-table-column>
                      <template #default="scope">
                        <el-row :gutter="20">
                          <el-col :span="10" style="height:120px;min-width:214px;">
                            <img v-if="scope.row.imageType === 'step'" src="@/assets/imgilluststep_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'eat'" src="@/assets/imgillusteat_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'stance'" src="@/assets/imgilluststance_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'spin'" src="@/assets/imgillustturning_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'foremilk'" src="@/assets/no_image_alert.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'calf'" src="@/assets/imgillustcalf_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imagePath === 'no'" src="@/assets/no_image_alert.png" class="img-size" />
                            <img v-if="scope.row.imageType === 'jpg'" v-bind:src="scope.row.imagePath"
                              crossorigin="use-credentials" class="img-size" @click="ImageDialogView(scope.row)" />
                          </el-col>
                          <el-col :span="14">
                            <el-row style="height:60px;">
                              <p style="font-weight:bold;">{{ scope.row.message }}</p>
                            </el-row>
                            <el-row style="height:60px;">
                              <p style="font-size:small;">{{ scope.row.datetime }}</p>
                            </el-row>
                          </el-col>
                        </el-row>
                      </template>
                    </el-table-column>
                    <el-table-column>
                      <template #default="scope">
                        <el-row style="justify-content:right;height:40px;">
                          <el-badge :is-dot="!scope.row.is_read"
                            style="width:100%;position:absolute;top:1px;left:96%;"></el-badge>
                        </el-row>
                        <el-row style="justify-content:right;height:40px;">
                          <el-icon v-if="scope.row.is_lock" style="color:#383838;padding-right:1em;">
                            <IconLock />
                          </el-icon>
                        </el-row>
                        <el-row style="justify-content:right;height:40px;">
                          <p v-if="scope.row.is_action" style="color:#383838;margin-block:0em;padding-right:1em;">対応済み
                          </p>
                          <p v-if="scope.row.is_wrong_detect" style="color:#383838;margin-block:0em;padding-right:1em;">
                            誤検知</p>
                        </el-row>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div v-if="!loading & (orgAlertsTable.length == 0 || alertsTable.length == 0)">
                  <el-row class="width100">
                    <el-row class="width100" style="justify-content:center;margin-top:10%;">
                      <p v-if="orgAlertsTable.length == 0" class="font_18 font_bold">現在イベントはありません</p>
                      <p v-if="orgAlertsTable.length != 0 & alertsTable.length == 0" class="font_18 font_bold">
                        該当するイベントはありません
                      </p>
                    </el-row>
                    <el-row class="width100" style="justify-content:center;">
                      <img src="@/assets/ImgIllustAlertEmpty.png" />
                    </el-row>
                  </el-row>
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div style="color:#383838;background:#F8F8F7;border-radius:8px;min-width:305px;">
                <el-row :gutter="20" style="margin-top:10px;">
                  <el-col :span="12">
                    <el-row>
                      <span class="filter_left font_bold">絞り込み</span>
                    </el-row>
                    <el-row style="margin-top: 7px;">
                      <span class="filter_left">イベント内容</span>
                    </el-row>
                  </el-col>
                  <el-row :gutter="20">
                    <el-col :span="1"></el-col>
                    <el-col :span="11" style="width:266px;">
                      <el-checkbox class="filter_left_checkbox" v-model="filter_baloon" label="羊膜検知"
                        @change="alertsDataFiltering()" />
                      <el-checkbox class="filter_left_checkbox" v-model="filter_tail" label="しっぽ検知"
                        @change="alertsDataFiltering()" />
                      <!-- <el-checkbox class="filter_left_checkbox" v-model="filter_kicking" label="足蹴り検知"
                        @change="alertsDataFiltering()" /> -->
                      <el-checkbox class="filter_left_checkbox" v-model="filter_pose" label="立ち座り検知"
                        @change="alertsDataFiltering()" />
                      <el-checkbox class="filter_left_checkbox" v-model="filter_leg" label="子牛足検知"
                        @change="alertsDataFiltering()" />
                      <el-checkbox class="filter_left_checkbox" v-model="filter_calfForemilk" label="初乳検知"
                        @change="alertsDataFiltering()" />
                      <el-checkbox class="filter_left_checkbox" v-model="filter_calfMove" label="子牛の運動量減少"
                        @change="alertsDataFiltering()" />
                    </el-col>
                    <el-col :span="3">
                      <!-- <el-checkbox v-model="filter_leg" label="子牛足検知" @change="alertsDataFiltering()" /> -->
                      <el-checkbox v-model="filter_move" label="歩数検知" @change="alertsDataFiltering()" />
                      <el-checkbox v-model="filter_feed" label="食事量の減少" @change="alertsDataFiltering()" />
                      <el-checkbox v-model="filter_spin" label="旋回検知" @change="alertsDataFiltering()" />
                      <el-checkbox v-model="filter_calfBirth" label="子牛誕生検知" @change="alertsDataFiltering()" />
                    </el-col>
                  </el-row>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <span class="filter_left">対応状況</span>
                  </el-col>
                  <el-row :gutter="20">
                    <el-col :span="1"></el-col>
                    <el-col :span="11" style="width:266px;">
                      <el-checkbox class="filter_left_checkbox" v-model="filter_notaction" label="未対応"
                        @change="alertsDataFiltering()" />
                      <el-checkbox class="filter_left_checkbox" v-model="filter_wrongdetect" label="誤検知"
                        @change="alertsDataFiltering()" />
                    </el-col>
                    <el-col :span="3">
                      <el-checkbox v-model="filter_action" label="対応済み" @change="alertsDataFiltering()" />
                    </el-col>
                  </el-row>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <span class="filter_left">その他</span>
                  </el-col>
                  <el-row :gutter="20">
                    <el-col :span="1"></el-col>
                    <el-col :span="11" style="width:266px;">
                      <el-checkbox class="filter_left_checkbox" v-model="filter_protection" label="保護"
                        @change="alertsDataFiltering()" />
                    </el-col>
                    <el-col :span="3">
                      <el-button round color="#FFFFFF" type="info" @click="filterClear()">
                        クリア
                      </el-button>
                    </el-col>
                  </el-row>
                </el-row>
              </div>
              <el-row style="margin-top:0.8em;margin-left:20px;">
                <v-date-picker ref="alertCalendar" class="alertDate" v-model="target_date" is-required
                  :min-date="alertMinDate" :max-date="new Date()" :disabled-dates="alertDates" @change="dateChange()"
                  @dayclick="dateChange()" />
              </el-row>
            </el-col>
          </el-row>
          <!-- 編集 -->
          <el-row :gutter="20" v-if="eventMenuRadio === '一覧' & edit_alert" style="justify-content:left;">
            <el-col :span="19">
              <el-row :gutter="20" style="margin-top:1em;">
                <div style="padding-left:58px;"><span style="font-size:small;">{{ report_view_date }}</span></div>
              </el-row>
              <div style="width:97%;height:620px;">
                <div v-if="alertsTable.length != 0">
                  <el-table :data="alertsTable" :default-sort="{ prop: 'date_time', order: 'descending' }"
                    class="event-table" height="620" :show-header="false" @selection-change="tableSelect" stripe>
                    <el-table-column type="selection" style="background:#EEEEEC;min-width:48px;" />
                    <el-table-column>
                      <template #default="scope">
                        <el-row :gutter="20">
                          <el-col :span="10" style="height:120px;min-width:214px;">
                            <img v-if="scope.row.imageType === 'step'" src="@/assets/imgilluststep_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'eat'" src="@/assets/imgillusteat_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'stance'" src="@/assets/imgilluststance_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'spin'" src="@/assets/imgillustturning_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'foremilk'" src="@/assets/no_image_alert.png"
                              class="img-size" />
                            <img v-if="scope.row.imageType === 'calf'" src="@/assets/imgillustcalf_pc.png"
                              class="img-size" />
                            <img v-if="scope.row.imagePath === 'no'" src="@/assets/no_image_alert.png" class="img-size" />
                            <img v-if="scope.row.imageType === 'jpg'" v-bind:src="scope.row.imagePath"
                              crossorigin="use-credentials" class="img-size" />
                          </el-col>
                          <el-col :span="14">
                            <el-row style="height:50%;">
                              <p style="font-weight:bold;">{{ scope.row.message }}</p>
                            </el-row>
                            <el-row style="height:50%;">
                              <p style="font-size:small;">{{ scope.row.datetime }}</p>
                            </el-row>
                          </el-col>
                        </el-row>
                      </template>
                    </el-table-column>
                    <el-table-column>
                      <template #default="scope">
                        <el-row style="justify-content:right;height:23px;">
                          <el-badge :is-dot="!scope.row.is_read"
                            style="width:100%;position:absolute;top:1px;left:96%;"></el-badge>
                        </el-row>
                        <el-row style="justify-content:right;height:23px;">
                          <el-icon v-if="scope.row.is_lock" style="color:#383838;padding-right:1em;">
                            <IconLock />
                          </el-icon>
                        </el-row>
                        <el-row style="justify-content:right;height:23px;">
                          <p v-if="scope.row.is_action" style="color:#383838;margin-block:0em;padding-right:1em;">対応済み
                          </p>
                          <p v-if="scope.row.is_wrong_detect" style="color:#383838;margin-block:0em;padding-right:1em;">
                            誤検知</p>
                        </el-row>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div v-if="!loading & alertsTable.length == 0">
                  <el-row class="width100">
                    <el-row class="width100" style="justify-content:center;margin-top:10%;">
                      <p class="font_18 font_bold">該当するイベントはありません</p>
                    </el-row>
                    <el-row class="width100" style="justify-content:center;">
                      <img src="@/assets/ImgIllustAlertEmpty.png" />
                    </el-row>
                  </el-row>
                </div>
              </div>
            </el-col>
            <el-col :span="1"></el-col>
            <el-col :span="4">
              <div>
                <el-row style="margin-top: 1em;">
                  <el-row :gutter="20" style="margin-top: 1em;">
                    <el-col :span="24">
                      <el-button class="button-style" color="#ffdf5e" style="width:214px;" round type="primary"
                        @click="alertAction()">対応済み</el-button>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" style="margin-top: 1em;">
                    <el-col :span="24">
                      <el-button class="button-style" color="#EEEEEC" style="width:214px;" round type="primary"
                        @click="alertWrong()">誤検知</el-button>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" style="margin-top: 1em;">
                    <el-col :span="24">
                      <el-button class="button-style" color="#EEEEEC" style="width:214px;" round type="primary"
                        @click="alertRead()">全既読</el-button>
                    </el-col>
                  </el-row>
                  <el-row :gutter="20" style="margin-top: 1em;">
                    <el-col :span="12">
                      <el-button class="button-style" color="#EEEEEC" style="width:100px;" round type="primary"
                        @click="alertDelete()">
                        <el-icon style="color: #383838; padding-right: 1em;">
                          <IconTrash />
                        </el-icon>削除
                      </el-button>
                    </el-col>
                    <el-col :span="12">
                      <el-button class="button-style" color="#EEEEEC" style="width:100px;" round type="primary"
                        @click="alertLock()">
                        <el-icon style="color: #383838; padding-right: 1em;">
                          <IconLock />
                        </el-icon>保護
                      </el-button>
                    </el-col>
                  </el-row>
                </el-row>
              </div>
              <el-row style="margin-top:4em;">
                <v-date-picker v-if="!edit_alert" is-required :max-date="new Date()" :disabled-dates="alertDates"
                  v-model="target_date" />
              </el-row>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="eventMenuRadio === 'グラフ'">
            <el-col :span="20"></el-col>
            <el-col :span="4"></el-col>
          </el-row>
        </el-main>
        <el-footer :style="{ overflow: 'hidden', background: 'white', paddingTop: '4px' }">
          <el-row v-if="edit_alert" style="justify-content: end;padding-right:84px;">
            <el-button class="button-style" color="#EEEEEC" style="width:214px;" round type="primary"
              @click="edit_alert = false">キャンセル</el-button>
          </el-row>
        </el-footer>
      </el-container>
    </el-container>
  </el-container>
  <el-dialog v-model="dialogImageVisible" title="アラート画像" width="80%" align-center destroy-on-close
    @close="dialogClose('dialogImageVisible')">
    <image-dialog :row="ImageDialogRow" @dialogClose="dialogClose" />
  </el-dialog>
</template>

<script>
import HeaderView from '../components/HeaderView';
import MenuView from '../components/MenuView';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { getCurrentUser, signout } from "./js/cognito";
import AWSAPI from './js/aws-api';
import { ElMessage } from 'element-plus';
import ImageDialog from "../components/ImageDialog.vue"
import ConstParam from './js/const';
import { shallowRef } from 'vue';
import * as icons from '../components/icons/modules'
import _ from 'lodash'

// ロケール設定・タイムゾーン設定
dayjs.locale('ja');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Tokyo');
// 最大値取得関数
const aryMax = function (a, b) { return Math.max(a, b); }
// 牛・子牛仮名称用
const cowNamePrefix = "母牛"
const youngCowNamePrefix = "子牛"
const cowNameAlias = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"

export default {
  name: 'LiveView',
  components: {
    HeaderView,
    MenuView,
    ImageDialog
  },
  props: {},
  created() {
    this.$store.commit('setCowMenuSelect', 'イベント');
  },
  mounted() {
    this.target_date = new Date();
    this.report_view_date = dayjs(this.target_date).format('YYYY/MM/DD (ddd)')
    this.restore_param();
    this.checkUserType()
    this.get_current_user();
    this.hoverCssDelete();
  },
  beforeUnmount() {
    this.hoverCssInsert();
  },
  data() {
    return {
      addBirthCalfData: null,
      actAlertNextFlg: false,
      isUserTypeDisabled: true,
      userType: ConstParam.disable_user_kind,
      editDisableAlerts: ConstParam.editDisableAlerts,
      cancelMessage: ConstParam.cancelMessage,
      cancelProtectMessage: ConstParam.cancelProtectMessage,
      protectMessage: ConstParam.protectMessage,
      deleteProtectMessage: ConstParam.deleteProtectMessage,
      reportMinDate: null,
      reportDates: [],
      targetReportDates: [],
      alertMinDate: null,
      alertDates: [],
      IconPencil: shallowRef(icons.IconPencil),
      IconLock: shallowRef(icons.IconLock),
      IconTrash: shallowRef(icons.IconTrash),
      saveStyle: [],
      // 複数頭・子牛レポート対応
      daysChangeFlg: false,
      saveCowTrackId: "",
      cowMoveMax: 0,
      cowPostureMax: 0,
      cowSpinMax: 0,
      youngCowMoveMax: 0,
      youngCowBreastfeedingMax: 0,
      reportInfo: [],
      isCalfReport: false,
      selectReportIndex: 0,
      select_cow_track_id: "",
      barnReportData: [],
      // 
      moveMax: 0,
      postureMax: 0,
      spinMax: 0,
      loadingImg: false,
      report_days: "1日",
      select_alert: [],
      edit_alert: false,
      cow_name: "",
      report_view_date: "",
      alert_edit_date: "",
      eventMenuRadio: "一覧",
      select_barn: "",
      select_barn_id: "",
      select_cow_id: "",
      cowTable: [],
      cowsData: {},
      target_date: "",
      report_target_date: "",
      calender_date: [],
      alertsData: [],
      barnsData: {},
      barnsInfoData: [],
      // ダイアログ
      dialogImageVisible: false,
      ImageDialogRow: {},
      // フィルター
      barnsFilter: [],
      filter_tail: false,
      filter_leg: false,
      filter_baloon: false,
      filter_kicking: false,
      filter_move: false,
      filter_feed: false,
      filter_pose: false,
      filter_spin: false,
      filter_calfMove: false,
      filter_calfBirth: false,
      filter_calfForemilk: false,
      filter_notaction: false,
      filter_wrongdetect: false,
      filter_action: false,
      filter_protection: false,
      // フィルターセーブ・ロード用
      filterParams: {
        save: false,
        filter_params: []
      },
      // テーブル
      alertsTable: [],
      reportTable: {},
      orgAlertsTable: [],
      // セレクト
      select_days: ConstParam.select_days,
      // 変換テーブル
      alert_message: ConstParam.alert_message,
      cow_kinds: ConstParam.cow_kinds,
      // レポートデータ
      reportsAllData: [],
      reportsDate: [],
      reportsData: [],
      reportMoveAlert: [],
      reportPostureAlert: [],
      reportSpinAlert: [],
      reportMoveData: [],
      reportPostureData: [],
      reportSpinData: [],
      // グラフ
      canvas_size: 1200,
      canvas: "",
      context: "",
      // ===== 以降固定 ====
      isAdmin: false,
      cow_menu_radio: "",
      loading: false,
      userData: {},
      farmer_id: "",
      viewUserName: "",
      viewFarmerName: "",
      logOut: false
      // ==================
    }
  },
  methods: {
    addBirthCalf: async function () {
      this.loading = true
      // WebAPI呼び出し.
      await AWSAPI.addBirthCalf(
        this.addBirthCalfData.barn_id,
        this.addBirthCalfData.date_time,
        this.addBirthCalfData.birth_id
      )
        .then((res) => {
          if (this.checkAnswer(res, true)) {
            this.viewMessage("「" + res.data.data[0].cow_name + "」として子牛を仮登録しました", "success")
            this.addBirthCalfData = null
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
          return
        });
    },
    checkUserType() {
      this.isUserTypeDisabled = true
      if (this.userType != ConstParam.disable_user_kind) {
        this.isUserTypeDisabled = false
      }
    },
    getErrorMessage(res) {
      if (
        'message' in res &&
        'response' in res.message &&
        'data' in res.message.response &&
        'message' in res.message.response.data
      ) {
        return res.message.response.data.message
      } else {
        return ""
      }
    },
    updateBarnInfo: async function () {
      // ログイン済みユーザー取得.
      this.loading = true;
      // WebAPI呼び出し.
      await AWSAPI.getCowReportDatesInBarn2(this.select_barn_id)
        .then((res) => {
          if (this.checkAnswer(res, true)) {
            let updateBarnData = res['data']['data'][0];
            this.setReportMax(updateBarnData)
            let barnIndex = this.barnsInfoData.findIndex(barns => barns.barn_id === this.select_barn_id)
            if (barnIndex != -1) {
              this.barnsInfoData[barnIndex].report_dates = []
              if ('report_dates' in updateBarnData) {
                for (let idy = 0; idy < updateBarnData.report_dates.length; idy++) {
                  this.barnsInfoData[barnIndex].report_dates.push(updateBarnData.report_dates[idy])
                }
              }
            }
            // カレンダー日付設定を更新
            this.setReportDates()
          }
        });
    },
    getCowReportData(cowReportData, isYoungCow) {
      let reportsData = []
      if ('dates' in cowReportData) {
        for (let idx = 0; idx < cowReportData.dates.length; idx++) {
          let report_date = cowReportData.dates[idx].date
          if ('reports' in cowReportData.dates[idx]) {
            for (let idz = 0; idz < cowReportData.dates[idx].reports.length; idz++) {
              let report_date_time = report_date + 'T' + cowReportData.dates[idx].reports[idz].time
              let tempData = {}
              if (!isYoungCow) {
                tempData = {
                  date_time: report_date_time,
                  is_move: cowReportData.dates[idx].reports[idz].is_move,
                  is_posture: cowReportData.dates[idx].reports[idz].is_posture,
                  is_spin_around: cowReportData.dates[idx].reports[idz].is_spin_around,
                  move_length: cowReportData.dates[idx].reports[idz].move_length,
                  posture_change: cowReportData.dates[idx].reports[idz].posture_change,
                  spin_around: cowReportData.dates[idx].reports[idz].spin_around
                }
              } else {
                tempData = {
                  date_time: report_date_time,
                  is_move: cowReportData.dates[idx].reports[idz].is_move,
                  is_calf_birth: cowReportData.dates[idx].reports[idz].is_calf_birth,
                  is_colostrum: cowReportData.dates[idx].reports[idz].is_colostrum,
                  move_length: cowReportData.dates[idx].reports[idz].move_length,
                  breast_feeding_freq: cowReportData.dates[idx].reports[idz].breast_feeding_freq
                }
              }
              reportsData.push(tempData)
            }
          }
        }
      }
      return reportsData
    },
    async getCowsByDate() {
      if (this.select_barn_id !== "") {
        this.loading = true
        this.targetReportDates = []
        this.barnReportData = []
        this.selectReportIndex = 0
        this.select_cow_track_id = ""
        // 対象日付の準備
        let tempDates = []
        let dateNumber = parseInt(this.report_days.replaceAll('日', '')) + 1 // 翌日の0時データ取得のため日数+1日とする
        for (let idx = 0; idx < dateNumber; idx++) {
          tempDates.push(dayjs(this.report_target_date).add(idx, 'd').format("YYYY-MM-DD"))
        }
        // 牛房の有効日付のみに絞り込み
        this.targetReportDates = this.getBarnReportEnableDate(this.select_barn_id, tempDates)
        await AWSAPI.getCowReportsInBarn2(this.select_barn_id, this.targetReportDates)
          .then((res) => {
            if (this.checkAnswer(res, false)) {
              this.barnReportData = res.data.data[0]
            }
          })
      } else {
        this.loading = false
      }
    },
    getBarnReportEnableDate(barnId, targetDate) {
      let barnIndex = this.barnsInfoData.findIndex(barn => barn.barn_id === barnId)
      let tempDates = []
      if (barnIndex != -1 &&
        'report_dates' in this.barnsInfoData[barnIndex] &&
        this.barnsInfoData[barnIndex].report_dates) {
        for (let idy = 0; idy < targetDate.length; idy++) {
          if (this.barnsInfoData[barnIndex].report_dates.includes(targetDate[idy])) {
            tempDates.push(targetDate[idy])
          }
        }
      }
      return tempDates
    },
    setReportMax(barnsData) {
      this.cowMoveMax = 0
      this.cowPostureMax = 0
      this.cowSpinMax = 0
      this.youngCowMoveMax = 0
      this.youngCowBreastFeedingMax = 0
      if ('report_max_value' in barnsData) {
        let tempData = structuredClone(barnsData.report_max_value)
        if ('cow' in tempData) {
          if ('move_length' in tempData.cow) {
            this.cowMoveMax = tempData.cow.move_length
          }
          if ('posture_change' in tempData.cow) {
            this.cowPostureMax = tempData.cow.posture_change
          }
          if ('spin_around' in tempData.cow) {
            this.cowSpinMax = tempData.cow.spin_around
          }
        }
        if ('young_cow' in tempData) {
          if ('move_length' in tempData.young_cow) {
            this.youngCowMoveMax = tempData.young_cow.move_length
          }
        }
        if ('young_cow' in tempData) {
          if ('breast_feeding_freq' in tempData.young_cow) {
            this.youngCowBreastFeedingMax = tempData.young_cow.breast_feeding_freq
          }
        }
      }
    },
    getAlertMessage(alertIndex) {
      let ret = ""
      let messageIndex = this.alert_message.findIndex(({ alert_index }) => alert_index == alertIndex)
      if (messageIndex != -1) {
        ret = this.alert_message[messageIndex].message_text
      }
      return ret
    },
    filterClear() {
      this.filter_tail = false;
      this.filter_leg = false;
      this.filter_baloon = false;
      this.filter_kicking = false;
      this.filter_move = false;
      this.filter_feed = false;
      this.filter_pose = false;
      this.filter_spin = false;
      this.filter_calf = false;
      this.filter_notaction = false;
      this.filter_wrongdetect = false;
      this.filter_action = false;
      this.filter_protection = false;
      this.alertsDataFiltering()
    },
    copyValue(item) {
      return JSON.parse(JSON.stringify(item));
    },
    setFilter() {
      const idx = this.barnsData.findIndex(barn => barn.barn_id === this.select_barn_id)
      if (idx != -1) {
        this.filter_tail = this.barnsFilter[idx].filter_tail;
        this.filter_leg = this.barnsFilter[idx].filter_leg;
        this.filter_baloon = this.barnsFilter[idx].filter_baloon;
        this.filter_kicking = this.barnsFilter[idx].filter_kicking;
        this.filter_move = this.barnsFilter[idx].filter_move;
        this.filter_feed = this.barnsFilter[idx].filter_feed;
        this.filter_pose = this.barnsFilter[idx].filter_pose;
        this.filter_spin = this.barnsFilter[idx].filter_spin;
        this.filter_calfMove = this.barnsFilter[idx].filter_calfMove;
        this.filter_calfBirth = this.barnsFilter[idx].filter_calfBirth;
        this.filter_calfForemilk = this.barnsFilter[idx].filter_calfForemilk;
        this.filter_notaction = this.barnsFilter[idx].filter_notaction;
        this.filter_wrongdetect = this.barnsFilter[idx].filter_wrongdetect;
        this.filter_action = this.barnsFilter[idx].filter_action;
        this.filter_protection = this.barnsFilter[idx].filter_protection;
      } else {
        this.filter_tail = false;
        this.filter_leg = false;
        this.filter_baloon = false;
        this.filter_kicking = false;
        this.filter_move = false;
        this.filter_feed = false;
        this.filter_pose = false;
        this.filter_spin = false;
        this.filter_calfMove = false;
        this.filter_calfBirth = false;
        this.filter_calfForemilk = false;
        this.filter_notaction = false;
        this.filter_wrongdetect = false;
        this.filter_action = false;
        this.filter_protection = false;
      }
    },
    saveFilterParams() {
      const idx = this.barnsData.findIndex(barn => barn.barn_id === this.select_barn_id)
      if (idx != -1 && !this.loading) {
        this.barnsFilter[idx].filter_tail = this.filter_tail;
        this.barnsFilter[idx].filter_leg = this.filter_leg;
        this.barnsFilter[idx].filter_baloon = this.filter_baloon;
        this.barnsFilter[idx].filter_kicking = this.filter_kicking;
        this.barnsFilter[idx].filter_move = this.filter_move;
        this.barnsFilter[idx].filter_feed = this.filter_feed;
        this.barnsFilter[idx].filter_pose = this.filter_pose;
        this.barnsFilter[idx].filter_spin = this.filter_spin;
        this.barnsFilter[idx].filter_calfMove = this.filter_calfMove;
        this.barnsFilter[idx].filter_calfBirth = this.filter_calfBirth;
        this.barnsFilter[idx].filter_calfForemilk = this.filter_calfForemilk;
        this.barnsFilter[idx].filter_notaction = this.filter_notaction;
        this.barnsFilter[idx].filter_wrongdetect = this.filter_wrongdetect;
        this.barnsFilter[idx].filter_action = this.filter_action;
        this.barnsFilter[idx].filter_protection = this.filter_protection;
        this.filterParams.save = true
        this.filterParams.filter_params = this.copyValue(this.barnsFilter);
      }
      this.$store.commit('setFilterParams', this.filterParams);
    },
    setReportDates() {
      let barnIndex = this.barnsInfoData.findIndex(barn => barn.barn_id === this.select_barn_id)
      let report_dates = []
      if (
        barnIndex != -1 &&
        'report_dates' in this.barnsInfoData[barnIndex] &&
        this.barnsInfoData[barnIndex].report_dates
      ) {
        report_dates = this.barnsInfoData[barnIndex].report_dates
      }
      this.report_target_date = ""
      let tempReportDates = []
      let tempReportDateMin = dayjs(new Date()).format('YYYY-MM-DD')
      let tempReportDateMax = tempReportDateMin
      for (let idx = 0; idx < report_dates.length; idx++) {
        const tempDate = report_dates[idx]
        tempReportDates.push(tempDate)
        if (tempReportDateMin > tempDate) {
          tempReportDateMin = tempDate
        }
      }
      let tempNewReportDates = Array.from(new Set(tempReportDates))
      if (tempNewReportDates.length > 0) {
        const tempFromDate = dayjs(tempReportDateMin);
        const tempToDate = dayjs(tempReportDateMax);
        const tempDiffDate = tempToDate.diff(tempFromDate);
        const tempDateCount = parseInt(tempDiffDate / (24 * 60 * 60 * 1000));
        // 最小日付以前の日付を無効可
        tempReportDates = [];
        let tempWork = dayjs(tempReportDateMin).subtract(1, 'd').format('YYYY-MM-DD');
        let tempDateData = { start: null, end: new Date(tempWork) };
        tempReportDates.push(tempDateData);
        for (let idx = 0; idx < (tempDateCount + 1); idx++) {
          tempWork = dayjs(tempReportDateMin).add(idx, 'd').format('YYYY-MM-DD');
          if (tempNewReportDates.indexOf(tempWork) == -1) {
            // 除外設定追加
            tempDateData = { start: new Date(tempWork), end: new Date(tempWork) };
            tempReportDates.push(tempDateData);
          } else {
            // 有効日付で選択日更新
            this.report_view_date = dayjs(tempWork).format('YYYY/MM/DD (ddd)')
          }
        }
      } else {
        // 本日以外無効
        tempReportDates = [];
        this.report_view_date = dayjs(tempReportDateMax).format('YYYY/MM/DD (ddd)')
      }
      this.reportDates = tempReportDates;
      this.report_target_date = dayjs(this.report_view_date).format('YYYY-MM-DD');
      this.reportMinDate = new Date(dayjs(tempReportDateMin));
      this.reportCalendarMove(this.report_target_date);
      // 牛房リポートデータ取得
      this.getCowsByDate()
    },
    setAlertDates() {
      this.target_date = "";
      let tempAlertDates = [];
      let tempAlertDateMin = dayjs(new Date()).format('YYYY-MM-DD');
      let tempAlertDateMax = tempAlertDateMin;
      for (let idx = 0; idx < this.orgAlertsTable.length; idx++) {
        const tempDate = this.orgAlertsTable[idx].date_time.substring(0, 10);
        tempAlertDates.push(tempDate);
        if (tempAlertDateMin > tempDate) {
          tempAlertDateMin = tempDate;
        }
      }
      let tempNewAlertDates = Array.from(new Set(tempAlertDates))
      if (tempNewAlertDates.length > 0) {
        const tempFromDate = dayjs(tempAlertDateMin);
        const tempToDate = dayjs(tempAlertDateMax);
        const tempDiffDate = tempToDate.diff(tempFromDate);
        const tempDateCount = parseInt(tempDiffDate / (24 * 60 * 60 * 1000));
        // 最小日付以前の日付を無効可
        tempAlertDates = [];
        let tempWork = dayjs(tempAlertDateMin).subtract(1, 'd').format('YYYY-MM-DD');
        let tempDateData = { start: null, end: new Date(tempWork) };
        tempAlertDates.push(tempDateData);
        for (let idx = 0; idx < (tempDateCount + 1); idx++) {
          tempWork = dayjs(tempAlertDateMin).add(idx, 'd').format('YYYY-MM-DD');
          if (tempNewAlertDates.indexOf(tempWork) == -1) {
            // 除外設定追加
            tempDateData = { start: new Date(tempWork), end: new Date(tempWork) };
            tempAlertDates.push(tempDateData);
          } else {
            // 有効日付で選択日更新
            this.report_view_date = dayjs(tempWork).format('YYYY/MM/DD (ddd)')
          }
        }
      } else {
        // 本日以外無効
        tempAlertDates = [];
        this.report_view_date = dayjs(tempAlertDateMax).format('YYYY/MM/DD (ddd)')
      }
      this.alertDates = tempAlertDates;
      this.target_date = dayjs(this.report_view_date).format('YYYY-MM-DD');
      this.alertMinDate = new Date(dayjs(tempAlertDateMin));
      this.alertCalendarMove(this.target_date);
      // レポートデータ取得
      this.getCowsByDate()
    },
    async alertCalendarMove(targetDate) {
      if (this.$refs.alertCalendar) {
        await this.$refs.alertCalendar.move(targetDate);
      }
    },
    async reportCalendarMove(targetDate) {
      if (this.$refs.reportCalendar) {
        await this.$refs.reportCalendar.move(targetDate);
      }
    },
    hoverCssDelete() {
      this.saveStyle = [];
      for (var si in document.styleSheets) {
        var styleSheet = document.styleSheets[si];
        if (!styleSheet.cssRules) continue;
        for (var ri = styleSheet.cssRules.length - 1; ri >= 0; ri--) {
          if (!styleSheet.cssRules[ri].selectorText) continue;
          if (styleSheet.cssRules[ri].selectorText.match(':hover')) {
            if (styleSheet.cssRules[ri].selectorText.indexOf('.el-table') != -1) {
              let tempStyle = styleSheet.cssRules[ri];
              this.saveStyle.push(tempStyle['cssText']);
              styleSheet.deleteRule(ri);
            }
          }
        }
      }
    },
    hoverCssInsert() {
      for (let i = 0; i < this.saveStyle.length; i++) {
        document.styleSheets.item(0).insertRule(this.saveStyle[i]);
      }
    },
    dialogClose(dialogName) {
      if (dialogName === "dialogImageVisible") {
        this.loadingImg = false;
        this.dialogImageVisible = false;
      }
    },
    ImageDialogView(row) {
      this.updateReadWithOtherAction([row.date_time]);
      row.is_read = true;
      this.ImageDialogRow = row;
      this.loadingImg = true;
      this.dialogImageVisible = true;
    },
    tableSelect(selection) {
      this.select_alert = selection;
    },
    report_frame() {
      // 初期値
      let start_x = 112;
      let start_y = 40;
      let line_h = 176;
      let hour_6 = 272;
      let offset_x = 40;
      let tempDays = this.report_days.replaceAll('日', '');
      // let index_line = 0;
      let index_col = 0;
      let position_x = hour_6 / 6;
      // let position_y = 80;
      let position_y = 176;
      const reportTable = this.reportTable;
      // キャンバス初期化
      this.canvas_size = start_x + hour_6 * 4 * parseInt(this.report_days.replaceAll('日', '')) + offset_x;
      this.canvas = this.$refs.canvas;
      this.canvas.width = this.canvas_size;
      // this.canvas.height = 400;
      this.canvas.height = 600;
      this.context = this.canvas.getContext("2d");
      const ctx = this.canvas.getContext("2d");
      this.rect = this.canvas.getBoundingClientRect();
      // フォント設定
      this.context.textAlign = "center";
      this.context.textBaseline = "bottom";
      this.context.font = "medium 'Noto Sans JP' normal";
      // 線色・面色
      this.context.strokeStyle = "#DBDCDD";
      this.context.fillStyle = "#F8F8F7";
      this.context.strokeRect(0, start_y, start_x, line_h);
      this.context.fillRect(0, start_y + line_h, start_x, line_h);
      this.context.strokeRect(0, start_y + line_h, start_x, line_h);
      if (!this.isCalfReport) {
        // this.context.fillRect(0, start_y + line_h, start_x, line_h);
        // this.context.strokeRect(0, start_y + line_h, start_x, line_h);
        this.context.strokeRect(0, start_y + line_h * 2, start_x, line_h);
      }
      // グラフ領域
      let time_line = 0;
      for (let i = 0; i < tempDays * 4; i++) {
        this.context.fillStyle = "#383838";
        this.context.fillText(String(i * 6), start_x + hour_6 * i, 30);
        if (i == (tempDays * 4 - 1)) {
          this.context.fillText(String((i + 1) * 6), start_x + hour_6 * (i + 1), 30);
        }
        this.context.fillStyle = "#F8F8F7";
        this.context.strokeRect(start_x + hour_6 * i, start_y, hour_6, line_h);
        this.context.fillRect(start_x + hour_6 * i, start_y + line_h, hour_6, line_h);
        this.context.strokeRect(start_x + hour_6 * i, start_y + line_h, hour_6, line_h);
        if (!this.isCalfReport) {
          // this.context.fillRect(start_x + hour_6 * i, start_y + line_h, hour_6, line_h);
          // this.context.strokeRect(start_x + hour_6 * i, start_y + line_h, hour_6, line_h);
          this.context.strokeRect(start_x + hour_6 * i, start_y + line_h * 2, hour_6, line_h);
        }
        time_line = time_line + 6;
      }
      // タイトル
      this.context.font = "16px Noto Sans JP";
      this.context.fillStyle = "#383838";
      if (!this.isCalfReport) {
        this.context.fillText("移動距離", 55, 130);
        this.context.fillText(" （m） ", 55, 148);
        this.context.fillText("立ち座り", 55, 310);
        this.context.fillText("（回）", 55, 328);
        this.context.fillText("旋  回", 55, 490);
        this.context.fillText("（回）", 55, 518);
      } else {
        this.context.fillText("集計時間", 55, 112);
        this.context.fillText("あたりの", 55, 130);
        this.context.fillText("授乳時間", 55, 148);
        this.context.fillText("（min）", 55, 167);
        this.context.fillText("移動距離", 55, 310);
        this.context.fillText(" （m） ", 55, 328);
      }
      // グラフ表示
      let moveMaxStr = "";
      let postureMaxStr = "";
      let spinMaxStr = "";
      let youngCowBreastfeedingMaxStr = "";
      if (this.moveMax == 0) {
        this.moveMax = 1;
      }
      moveMaxStr = String(this.moveMax);
      if (this.postureMax == 0) {
        this.postureMax = 1;
      }
      postureMaxStr = String(this.postureMax);
      if (this.spinMax == 0) {
        this.spinMax = 1;
      }
      spinMaxStr = String(this.spinMax);
      if (this.youngCowBreastfeedingMax == 0) {
        this.youngCowBreastfeedingMax = 1
      }
      youngCowBreastfeedingMaxStr = String(this.youngCowBreastfeedingMax);
      // 最大・最小表示
      let x_offset = -5;
      let y_upper_offset = 13;
      let y_lowwer_offset = -4;
      this.context.font = "10px Noto Sans JP";
      this.context.textAlign = "right"; // 右寄せ
      if (!this.isCalfReport) {
        if (this.moveMax) {
          this.context.fillText(moveMaxStr, start_x + x_offset, start_y + y_upper_offset);
        }
        this.context.fillText("0", start_x + x_offset, start_y + position_y + y_lowwer_offset);
        if (this.postureMax) {
          this.context.fillText(postureMaxStr, start_x + x_offset, start_y + position_y + y_upper_offset);
        }
        this.context.fillText("0", start_x + x_offset, start_y + position_y * 2 + y_lowwer_offset);
        if (this.spinMax) {
          this.context.fillText(spinMaxStr, start_x + x_offset, start_y + position_y * 2 + y_upper_offset);
        }
        this.context.fillText("0", start_x + x_offset, start_y + position_y * 3 + y_lowwer_offset);
      } else {
        if (this.youngCowBreastfeedingMax) {
          this.context.fillText(youngCowBreastfeedingMaxStr, start_x + x_offset, start_y + y_upper_offset);
        }
        this.context.fillText("0", start_x + x_offset, start_y + position_y + y_lowwer_offset);
        if (this.moveMax) {
          this.context.fillText(moveMaxStr, start_x + x_offset, start_y + position_y + y_upper_offset);
        }
        this.context.fillText("0", start_x + x_offset, start_y + position_y * 2 + y_lowwer_offset);
      }
      ctx.strokeStyle = "#807F7D";
      ctx.lineWidth = 2;
      this.context.textAlign = "start"; // 元の設定へ戻す
      // アラート描画
      this.context.fillStyle = "#DA4200";
      ctx.globalAlpha = 0.2;
      let start_index_line = 0;
      let end_index_line = 2;
      if (this.isCalfReport) {
        start_index_line = 3;
        end_index_line = 5;
      }
      for (let index_line = start_index_line; index_line <= end_index_line; index_line++) {
        for (index_col = 0; index_col < reportTable.alertData[index_line].length; index_col++) {
          let status = reportTable.alertData[index_line][index_col];
          if (status == 2) {
            let tempIndexLine = index_line
            if (index_line >= 3) {
              if (index_line < 5) {
                // 誕生検知・初乳検知は子牛グラフの授乳頻度グラフに表示
                tempIndexLine = 0
              } else {
                // 移動量グラフに表示
                tempIndexLine = 1
              }
            }
            let lx = start_x + position_x * index_col - 7;
            let ly = start_y + line_h * tempIndexLine + 1;
            let barWidth = 15;
            if (index_col == 0) {
              lx = lx + 7;
              barWidth = 8;
            } else if (index_col == reportTable.alertData[index_line].length - 1) {
              barWidth = 8;
            }
            this.context.fillStyle = "red";
            if (index_line == 3) {
              this.context.fillStyle = "#FFDF5E";
              this.context.fillRect(lx, ly, barWidth, line_h - 2);
              let lineStep = 18
              let lineOffset = 54
              this.context.font = "16px Noto Sans JP";
              this.context.fillStyle = "RED";
              let tempLx = lx;
              if (index_col == reportTable.alertData[index_line].length - 1) {
                tempLx = tempLx - 8
              }
              for (let x = 0; x < 3; x++) {
                this.context.fillText("子", tempLx, ly + lineOffset);
                this.context.fillText("牛", tempLx, ly + lineOffset + lineStep);
                this.context.fillText("誕", tempLx, ly + lineOffset + lineStep * 2);
                this.context.fillText("生", tempLx, ly + lineOffset + lineStep * 3);
              }
              this.context.fillStyle = "#DA4200";
            } else {
              this.context.fillRect(lx, ly, barWidth, line_h - 2);
            }
          }
        }
      }
      this.context.fillStyle = "#383838";
      ctx.globalAlpha = 1.0; // 透明度100%
      let y_offset = 8;
      if (!this.isCalfReport) {
        // 親牛グラフ
        // 移動距離グラフ
        let lastDraw = false;
        for (index_col = 0; index_col < reportTable.alertData[0].length; index_col++) {
          let moveData = reportTable.graphData[0][index_col];
          let locate_x = start_x + position_x * index_col;
          let locate_y = start_y + position_y - y_offset - (moveData * ((line_h - y_offset * 2) / this.moveMax)) - 1;
          if (reportTable.graphData[1][index_col] == 1) {
            if (!lastDraw) {
              ctx.moveTo(locate_x, locate_y);// 始点
            } else {
              ctx.lineTo(locate_x, locate_y);// 終点
            }
            lastDraw = true;
          } else {
            lastDraw = false;
          }
        }
        ctx.stroke();
        // 立ち座りグラフ
        lastDraw = false;
        for (index_col = 0; index_col < reportTable.alertData[1].length; index_col++) {
          let postureData = reportTable.graphData[2][index_col];
          let locate_x = start_x + position_x * index_col;
          let locate_y = start_y + position_y * 2 - y_offset - (postureData * ((line_h - y_offset * 2) / this.postureMax)) - 1;
          if (reportTable.graphData[3][index_col] == 1) {
            if (!lastDraw) {
              ctx.moveTo(locate_x, locate_y);// 始点
            } else {
              ctx.lineTo(locate_x, locate_y);// 終点
            }
            lastDraw = true;
          } else {
            lastDraw = false;
          }
        }
        ctx.stroke();
        // 旋回グラフ
        lastDraw = false;
        for (index_col = 0; index_col < reportTable.alertData[2].length; index_col++) {
          let spinData = reportTable.graphData[4][index_col];
          let locate_x = start_x + position_x * index_col;
          let locate_y = start_y + position_y * 3 - y_offset - (spinData * ((line_h - y_offset * 2) / this.spinMax)) - 1;
          if (reportTable.graphData[5][index_col] == 1) {
            if (!lastDraw) {
              ctx.moveTo(locate_x, locate_y);// 始点
            } else {
              ctx.lineTo(locate_x, locate_y);// 終点
            }
            lastDraw = true;
          } else {
            lastDraw = false;
          }
        }
        ctx.stroke();
      } else {
        // 子牛グラフ
        // 授乳頻度グラフ
        let lastDraw = false;
        for (index_col = 0; index_col < reportTable.alertData[4].length; index_col++) {
          let breastfeedingData = reportTable.graphData[6][index_col];
          let locate_x = start_x + position_x * index_col;
          let locate_y = start_y + position_y - y_offset - (breastfeedingData * ((line_h - y_offset * 2) / this.youngCowBreastfeedingMax)) - 1;
          if (reportTable.graphData[7][index_col] == 1) {
            if (!lastDraw) {
              ctx.moveTo(locate_x, locate_y);// 始点
            } else {
              ctx.lineTo(locate_x, locate_y);// 終点
            }
            lastDraw = true;
          } else {
            lastDraw = false;
          }
        }
        ctx.stroke();
        // 移動距離グラフ
        lastDraw = false;
        for (index_col = 0; index_col < reportTable.graphData[0].length; index_col++) {
          let moveData = reportTable.graphData[0][index_col];
          let locate_x = start_x + position_x * index_col;
          let locate_y = start_y + position_y * 2 - y_offset - (moveData * ((line_h - y_offset * 2) / this.moveMax)) - 1;
          if (reportTable.graphData[1][index_col] == 1) {
            if (!lastDraw) {
              ctx.moveTo(locate_x, locate_y);// 始点
            } else {
              ctx.lineTo(locate_x, locate_y);// 終点
            }
            lastDraw = true;
          } else {
            lastDraw = false;
          }
        }
        ctx.stroke();
      }
    },
    editAlert() {
      this.edit_alert = true;
      this.alert_edit_date = this.report_view_date;
      this.select_alert = [];
    },
    notSelectAlert() {
      this.alertMessage("エラー", "イベントが１つも選択されておりません。");
    },
    alertLock() {
      if (this.select_alert.length == 0) {
        this.notSelectAlert();
      } else {
        let message = "";
        let is_lock = !this.checkSelectAlert("保護");
        let tempConfirmBtn = "保護";
        if (!is_lock) {
          message = "イベントの保護を解除";
          tempConfirmBtn += "解除";
        } else {
          message = "イベントを保護";
        }
        this.$confirm(message + "しますか？", "", {
          confirmButtonText: tempConfirmBtn,
          cancelButtonText: 'キャンセル',
          type: 'warning'
        }).then(() => {
          this.updateLock(is_lock, message);
        }).catch(() => {
          return
        });
      }
    },
    alertDelete() {
      if (this.select_alert.length == 0) {
        this.notSelectAlert();
      } else {
        let message2 = "";
        if (this.checkSelectAlert("削除")) {
          message2 = this.deleteProtectMessage;
        }
        let message = ("イベントを削除");
        this.$confirm(message + "しますか？" + message2, "", {
          confirmButtonText: '削除',
          cancelButtonText: 'キャンセル',
          type: 'warning'
        }).then(() => {
          this.updateDelete(message);
        }).catch(() => {
          return
        });
      }
    },
    alertRead() {
      if (this.alertsTable.length == 0) {
        this.notSelectAlert();
      } else {
        if (!this.checkSelectAlert("既読")) {
          this.alertMessage("", "すでに全てのイベントが既読の状態です。");
        } else {
          let message2 = "";
          let message = "全てのイベントを既読";
          this.$confirm(message + "にしますか？" + message2, "", {
            confirmButtonText: '全既読',
            cancelButtonText: 'キャンセル',
            type: 'warning'
          }).then(() => {
            this.updateRead(message);
          }).catch(() => {
            return
          });
        }
      }
    },
    alertWrong() {
      if (this.select_alert.length == 0) {
        this.notSelectAlert();
      } else {
        let message2 = "";
        if (this.checkSelectAlert("")) {
          message2 = this.protectMessage;
        }
        if (this.checkSelectAlert("出産兆候")) {
          if (message2 !== "") {
            message2 = this.cancelProtectMessage;
          } else {
            message2 = this.cancelMessage;
          }
        }
        let is_wrong_detect = !this.checkSelectAlert("誤検知")
        let message = "";
        let tempConfirmBtn = "誤検知";
        if (!is_wrong_detect) {
          message = "イベントの誤検知を解除";
          tempConfirmBtn += "解除";
        } else {
          message = "イベントを誤検知";
        }
        this.$confirm(message + "にしますか？" + message2, "", {
          confirmButtonText: tempConfirmBtn,
          cancelButtonText: 'キャンセル',
          type: 'warning'
        }).then(() => {
          this.updateWrong(is_wrong_detect, message);
        }).catch(() => {
          return
        });
      }
    },
    alertAction() {
      if (this.select_alert.length == 0) {
        this.notSelectAlert();
      } else {
        let message2 = "";
        let tempConfirmBtn = "対応済み";
        if (this.checkSelectAlert("")) {
          message2 = this.protectMessage;
        }
        if (this.checkSelectAlert("出産兆候")) {
          if (message2 !== "") {
            message2 = this.cancelProtectMessage;
          } else {
            message2 = this.cancelMessage;
          }
        }
        let is_action = !this.checkSelectAlert("対応済み");
        let message = "";
        if (!is_action) {
          message = "イベントの対応済みを解除";
          tempConfirmBtn += "解除";
        } else {
          message = "イベントを対応済み";
        }
        this.$confirm(message + "にしますか？" + message2, "", {
          confirmButtonText: tempConfirmBtn,
          cancelButtonText: 'キャンセル',
          type: 'warning'
        }).then(() => {
          this.updateAction(is_action, message);
        }).catch(() => {
          return
        });
      }
    },
    updateLock: async function (is_lock, message) {
      this.loading = true
      // WebAPI呼び出し.
      let lockFreeFlg = true
      let exclusionAlertEnabled = false
      await AWSAPI.lockAlert(this.select_barn_id, this.getAlertDateTime(lockFreeFlg, exclusionAlertEnabled), is_lock)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.viewMessage(message + "にしました。", "success")
          }
          this.get_alerts_data()
        });
    },
    updateDelete: async function (message) {
      this.loading = true
      // WebAPI呼び出し.
      let lockFreeFlg = false
      let exclusionAlertEnabled = false
      await AWSAPI.deleteAlert(this.select_barn_id, this.getAlertDateTime(lockFreeFlg, exclusionAlertEnabled))
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.viewMessage(message + "にしました。", "success")
          }
          this.get_alerts_data()
        });
    },
    updateReadWithOtherAction: async function (alertDates) {
      // WebAPI呼び出し.
      await AWSAPI.readAlert(this.select_barn_id, alertDates)
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            // ここで未読フラグを落とす
          }
          this.get_alerts_data()
        });
    },
    updateRead: async function (message) {
      this.loading = true;
      // WebAPI呼び出し.
      await AWSAPI.readAlert(this.select_barn_id, this.getAlertDateTimeAll())
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.viewMessage(message + "にしました。", "success");
          }
          this.get_alerts_data();
        });
    },
    updateWrong: async function (is_wrong_detect, message) {
      this.loading = true;
      // WebAPI呼び出し.
      let targetAlertsDateTime = this.getAlertDateTime(false);
      if (targetAlertsDateTime.length > 0) {
        await AWSAPI.wrongDetectAlert(this.select_barn_id, this.getAlertDateTime(false), is_wrong_detect)
          .then((res) => {
            if (this.checkAnswer(res, false)) {
              this.viewMessage(message + "にしました。", "success");
              this.updateReadWithOtherAction(this.getAlertDateTime(false));
            } else {
              this.get_alerts_data();
            }
          });
      } else {
        this.get_alerts_data();
      }
    },
    updateAction: async function (is_action, message) {
      this.loading = true;
      this.actAlertNextFlg = false;
      let targetAlertsDateTime = this.getAlertDateTime(false);
      if (targetAlertsDateTime.length > 0) {
        // WebAPI呼び出し.
        await AWSAPI.actAlert(this.select_barn_id, targetAlertsDateTime, is_action)
          .then((res) => {
            if (this.checkAnswer(res, false)) {
              this.viewMessage(message + "にしました。", "success");
              this.updateReadWithOtherAction(this.getAlertDateTime(false));
              if ("next" in res.data) {
                this.addBirthCalfData = structuredClone(res.data.next);
                this.actAlertNextFlg = true;
              }
            } else {
              this.get_alerts_data();
            }
          });
      } else {
        this.get_alerts_data();
      }
    },
    getAlertDateTime(lockFreeFlg, exclusionAlertEnabled = true) {
      let tempDateTimes = [];
      for (let idx = 0; idx < this.select_alert.length; idx++) {
        if (
          (lockFreeFlg || !this.select_alert[idx].is_lock) &&
          (!exclusionAlertEnabled || !(this.editDisableAlerts.indexOf(this.select_alert[idx].alert_type) != -1))
        ) {
          tempDateTimes.push(this.select_alert[idx].date_time)
        }
      }
      return tempDateTimes;
    },
    getAlertDateTimeAll() {
      let tempDateTimes = [];
      for (let idx = 0; idx < this.alertsTable.length; idx++) {
        tempDateTimes.push(this.alertsTable[idx]["date_time"])
      }
      return tempDateTimes;
    },
    checkSelectAlert(alertType) {
      let notinBirthSigns = false;
      if (alertType === "保護") {
        return this.checkStatus(this.select_alert, true, "is_lock");
      } else if (alertType === "誤検知") {
        return this.checkStatus(this.select_alert, true, "is_wrong_detect", notinBirthSigns);
      } else if (alertType === "対応済み") {
        return this.checkStatus(this.select_alert, true, "is_action", notinBirthSigns);
      } else if (alertType === "既読") {
        // ここだけアラート全体の未読を無条件で対象とする
        return !this.checkStatus(this.alertsTable, true, "is_read");
      } else if (alertType === "既読保護") {
        // ここだけアラート全体の未読を無条件で対象とする
        return this.checkStatus(this.alertsTable, false, "is_lock");
      } else if (alertType === "出産兆候") {
        return this.checkStatus(this.select_alert, false, "is_birth_signs");
      } else {
        return this.checkStatus(this.select_alert, false, "is_lock");
      }
    },
    checkStatus(arrayData, onlyMode, selectStatus, inBirthSigns = true) {
      let tempStatus = onlyMode
      let dataCount = 0
      for (let idx = 0; idx < arrayData.length; idx++) {
        if (selectStatus === "is_birth_signs") {
          tempStatus = tempStatus || (this.editDisableAlerts.indexOf(arrayData[idx].alert_type) != -1);
        } else {
          if (onlyMode) {
            if (inBirthSigns) {
              // 出産兆候のイベントを含む
              tempStatus = tempStatus && arrayData[idx][selectStatus]
              dataCount++
            } else {
              // 出産兆候イベントを含ない
              if (this.editDisableAlerts.indexOf(arrayData[idx].alert_type) == -1) {
                tempStatus = tempStatus && arrayData[idx][selectStatus]
                dataCount++
              }
            }
          } else {
            tempStatus = tempStatus || arrayData[idx][selectStatus]
          }
        }
      }
      if (onlyMode && dataCount == 0) {
        tempStatus = false
      }
      return tempStatus;
    },
    daysChange() {
      this.daysChangeFlg = true
      this.saveCowTrackId = this.select_cow_track_id
      // レポートデータ取得
      this.getCowsByDate()
    },
    dateChange() {
      if (this.eventMenuRadio === "グラフ") {
        this.selectReportIndex = 0
        this.report_view_date = dayjs(this.report_target_date).format('YYYY/MM/DD (ddd)')
        this.get_reports_all_data()
        // レポートデータ取得
        this.getCowsByDate()
      } else {
        this.report_view_date = dayjs(this.target_date).format('YYYY/MM/DD (ddd)')
        this.alertsDataFiltering()
      }
    },
    cowChange() {
      this.select_cow_id = ""
      this.loading = true
      // レポートデータ取得
      let reportIndex = this.reportInfo.findIndex(report => report.cow_track_id === this.select_cow_track_id)
      if (reportIndex != -1) {
        this.selectReportIndex = reportIndex
        this.get_reports_all_data()
      }
    },
    barnChange() {
      this.select_cow_id = ""
      this.selectReportIndex = 0
      this.select_cow_track_id = ""
      this.isCalfReport = false
      this.setFilter()
      this.set_cow_name()
      this.loading = true
      if (this.eventMenuRadio === "グラフ") {
        this.report_view_date = dayjs(this.report_target_date).format('YYYY/MM/DD (ddd)')
        // 牛房情報更新
        this.updateBarnInfo()
      } else {
        this.get_alerts_data()
      }
    },
    set_cow_name() {
      this.cow_name = "";
      const idx = this.barnsData.findIndex(barn => barn.barn_id === this.select_barn_id)
      if (idx != -1) {
        this.select_barn = this.barnsData[idx]["barn_name"];
        this.cow_name = this.set_cow_name_sub(this.select_barn, idx)
      }
    },
    set_cow_name_sub(barnName, idx) {
      let cowName = barnName + " ";
      if (this.barnsData[idx]["cow_id"].length > 0) {
        let cowData = [];
        if ("cows" in this.barnsData[idx]) {
          cowData = _.cloneDeep(this.barnsData[idx].cows)
        }
        if (cowData.length == 1) {
          cowName += "(" + cowData[0]['cow_name'] + ")";
        } else if (cowData.length > 1) {
          cowName += "(" + cowData[0]['cow_name'] + " 他" + (cowData.length - 1) + "頭" + ")";
        }
      }
      return cowName
    },
    set_cows_data(select_cow_id) {
      // 牛一覧情報作成
      this.cowTable = [];
      for (let idx = 0; idx < this.tableData.length; idx++) {
        if (select_cow_id.indexOf(this.tableData[idx]['id']) != -1) {
          this.cowTable.push(this.tableData[idx]);
        }
      }
    },
    radioChange() {
      this.loading = true
      this.edit_alert = false
      if (this.eventMenuRadio === "一覧") {
        this.get_alerts_data()
      } else {
        // レポート表示切替
        this.barnChange()
      }
    },
    get_alerts_data: async function () {
      if (this.select_barn_id !== "") {
        this.loading = true;
        await AWSAPI.getCowAlertsInBarn(this.select_barn_id)
          .then((res) => {
            if (this.checkAnswer(res, false)) {
              this.alertsData = res['data']['data'];
            }
          });
      } else {
        this.loading = false;
      }
    },
    get_reports_all_data() {
      this.reportsAllData = []
      this.loading = true;
      // 初期値
      let start_x = 112;
      let hour_6 = 272;
      let offset_x = 40;
      // キャンバス初期化
      this.canvas_size = start_x + hour_6 * 4 * parseInt(this.report_days.replaceAll('日', '')) + offset_x;
      this.isCalfReport = this.reportInfo[this.selectReportIndex].is_young_cow
      this.cowMoveMax = this.reportInfo[this.selectReportIndex].move_length
      if (this.cowMoveMax == null) { this.cowMoveMax = 0 }
      if (!this.isCalfReport) {
        this.cowPostureMax = this.reportInfo[this.selectReportIndex].posture_change
        this.cowSpinMax = this.reportInfo[this.selectReportIndex].spin_around
        if (this.cowPostureMax == null) { this.cowPostureMax = 0 }
        if (this.cowSpinMax == null) { this.cowSpinMax = 0 }
      } else {
        this.youngCowMoveMax = this.reportInfo[this.selectReportIndex].move_length
        if ("breast_feeding_freq" in this.reportInfo[this.selectReportIndex]) {
          this.youngCowBreastFeedingMax = this.reportInfo[this.selectReportIndex].breast_feeding_freq
          if (this.youngCowBreastFeedingMax == null) { this.youngCowBreastFeedingMax = 0 }
        }
      }
      this.reportsAllData = this.reportInfo[this.selectReportIndex].reports
    },
    drawReport: async function () {
      this.loading = true;
      // 初期値
      let start_x = 112;
      let hour_6 = 272;
      let offset_x = 40;
      // データ初期化
      this.reportTable = {}
      // キャンバス初期化
      this.canvas_size = start_x + hour_6 * 4 * parseInt(this.report_days.replaceAll('日', '')) + offset_x;
      // グラフ表示
      let tempMoveAlert = [];
      let tempPostureAlert = [];
      let tempSpinAlert = [];
      let tempCalfBirthAlert = [];
      let tempColostrumAlert = [];
      let tempMoveData = [];
      let tempPostureData = [];
      let tempSpinData = [];
      let tempBreastFeedingData = [];
      let tempMoveEnv = [];
      let tempPostureEnv = [];
      let tempSpinEnv = [];
      let tempBreastFeedingEnv = [];
      let tempStartDateStr = dayjs(this.report_target_date).format("YYYY-MM-DD") + "T00:00:00";
      let tempEndDateStr = dayjs(this.report_target_date).add(parseInt(this.report_days.replaceAll('日', '')), 'd').format("YYYY-MM-DD") + "T00:59:59";
      let tempStartDate = dayjs(tempStartDateStr);
      for (let idx = 0; idx < parseInt(this.report_days) * 24 + 1; idx++) {
        tempMoveAlert.push(0);
        tempPostureAlert.push(0);
        tempSpinAlert.push(0);
        tempCalfBirthAlert.push(0);
        tempColostrumAlert.push(0);
        tempMoveData.push(0.0);
        tempPostureData.push(0);
        tempSpinData.push(0);
        tempBreastFeedingData.push(0);
        tempMoveEnv.push(0);
        tempPostureEnv.push(0);
        tempSpinEnv.push(0);
        tempBreastFeedingEnv.push(0);
      }
      for (let idx = 0; idx < this.reportsAllData.length; idx++) {
        if (this.reportsAllData[idx].date_time < tempStartDateStr || this.reportsAllData[idx].date_time > tempEndDateStr) {
          continue;
        }
        let tempDataDate = dayjs(this.reportsAllData[idx].date_time);
        let timeIndex = tempDataDate.diff(tempStartDate, 'hour', false);
        let tempMoveAlertData = 0;
        let tempPostureAlertData = 0;
        let tempSpinAlertData = 0;
        let tempCalfBirthAlertData = 0;
        let tempColostrumAlertData = 0;
        // alert_dataとのマージ
        if (this.reportsAllData[idx].is_move) {
          tempMoveAlertData = 2;
        }
        if (!this.isCalfReport) {
          if (this.reportsAllData[idx].is_posture) {
            tempPostureAlertData = 2;
          }
          if (this.reportsAllData[idx].is_spin_around) {
            tempSpinAlertData = 2;
          }
        } else {
          if ('is_calf_birth' in this.reportsAllData[idx] && this.reportsAllData[idx].is_calf_birth) {
            tempCalfBirthAlertData = 2;
          }
          if ('is_colostrum' in this.reportsAllData[idx] && this.reportsAllData[idx].is_colostrum) {
            tempColostrumAlertData = 2;
          }
        }
        tempMoveAlert[timeIndex] = tempMoveAlertData;
        tempPostureAlert[timeIndex] = tempPostureAlertData;
        tempSpinAlert[timeIndex] = tempSpinAlertData;
        tempCalfBirthAlert[timeIndex] = tempCalfBirthAlertData;
        tempColostrumAlert[timeIndex] = tempColostrumAlertData;
        if ('move_length' in this.reportsAllData[idx] && !(this.reportsAllData[idx].move_length == null)) {
          tempMoveData[timeIndex] = this.reportsAllData[idx].move_length;
          tempMoveEnv[timeIndex] = 1;
        }
        if (!this.isCalfReport) {
          if ('posture_change' in this.reportsAllData[idx] && !(this.reportsAllData[idx].posture_change == null)) {
            tempPostureData[timeIndex] = this.reportsAllData[idx].posture_change;
            tempPostureEnv[timeIndex] = 1;
          }
          if ('spin_around' in this.reportsAllData[idx] && !(this.reportsAllData[idx].spin_around == null)) {
            tempSpinData[timeIndex] = this.reportsAllData[idx].spin_around;
            tempSpinEnv[timeIndex] = 1;
          }
        } else {
          if ('breast_feeding_freq' in this.reportsAllData[idx] && !(this.reportsAllData[idx].breast_feeding_freq == null)) {
            tempBreastFeedingData[timeIndex] = this.reportsAllData[idx].breast_feeding_freq;
            tempBreastFeedingEnv[timeIndex] = 1;
          }
        }
      }
      this.reportTable = {
        alertData: {
          0: tempMoveAlert,
          1: tempPostureAlert,
          2: tempSpinAlert,
          3: tempCalfBirthAlert,
          4: tempColostrumAlert,
          5: tempMoveAlert
        },
        graphData: {
          0: tempMoveData,
          1: tempMoveEnv,
          2: tempPostureData,
          3: tempPostureEnv,
          4: tempSpinData,
          5: tempSpinEnv,
          6: tempBreastFeedingData,
          7: tempBreastFeedingEnv
        }
      }
      this.report_frame();
      this.loading = false;
    },
    barnsInfoDataSet() {
      this.select_barn = "";
      this.select_cow_id = "";
      let first_flg = true;
      this.barnsInfoData = [];
      this.barnsFilter = [];
      for (let idx = 0; idx < this.barnsData.length; idx++) {
        let tempCows = [];
        if ("cow_id" in this.barnsData[idx]) {
          for (let idy = 0; idy < this.barnsData[idx]["cow_id"].length; idy++) {
            let temp_id = this.selectCowsDataID(this.barnsData[idx]["cow_id"][idy]);
            if (temp_id != -1) {
              tempCows.push(this.cowsData[temp_id]);
            }
          }
        }
        let tempData = {
          id: idx,
          barn_id: this.barnsData[idx].barn_id,
          barn_name: this.barnsData[idx].barn_name,
          barn_name_sub: this.set_cow_name_sub(this.barnsData[idx].barn_name, idx),
          report_dates: this.barnsData[idx].report_dates,
          cow_data: tempCows
        }
        this.barnsInfoData.push(tempData);
        if (first_flg) {
          first_flg = false;
          this.select_barn = this.barnsData[idx]["barn_name"];
          this.select_barn_id = this.barnsData[idx]["barn_id"];
          if (tempCows.length > 0) {
            // this.select_cow_id = _.cloneDeep(tempCows);
            let select_cow_id = _.cloneDeep(tempCows);
            this.set_cows_data(select_cow_id);
          }
          // 複数頭対応
          this.setReportDates()
        }
        let tempFilter = {
          filter_tail: false,
          filter_leg: false,
          filter_baloon: false,
          filter_kicking: false,
          filter_move: false,
          filter_feed: false,
          filter_pose: false,
          filter_spin: false,
          filter_calfMove: false,
          filter_calfBirth: false,
          filter_calfForeMilk: false,
          filter_notaction: false,
          filter_wrongdetect: false,
          filter_action: false,
          filter_protection: false
        }
        this.barnsFilter.push(tempFilter);
        if (this.filterParams.save && this.barnsFilter.length == this.filterParams.filter_params.length) {
          this.barnsFilter = this.copyValue(this.filterParams.filter_params);
          this.filter_tail = this.barnsFilter[0].filter_tail;
          this.filter_leg = this.barnsFilter[0].filter_leg;
          this.filter_baloon = this.barnsFilter[0].filter_baloon;
          this.filter_kicking = this.barnsFilter[0].filter_kicking;
          this.filter_move = this.barnsFilter[0].filter_move;
          this.filter_feed = this.barnsFilter[0].filter_feed;
          this.filter_pose = this.barnsFilter[0].filter_pose;
          this.filter_spin = this.barnsFilter[0].filter_spin;
          this.filter_calf = this.barnsFilter[0].filter_calf;
          this.filter_notaction = this.barnsFilter[0].filter_notaction;
          this.filter_wrongdetect = this.barnsFilter[0].filter_wrongdetect;
          this.filter_action = this.barnsFilter[0].filter_action;
          this.filter_protection = this.barnsFilter[0].filter_protection;
        }
      }
    },
    selectCowsDataID(cow_id) {
      let ret = -1;
      for (let idx = 0; idx < this.cowsData.length; idx++) {
        if ("cow_id" in this.cowsData[idx] && this.cowsData[idx]["cow_id"] == cow_id) {
          ret = idx;
          break;
        }
      }
      return ret;
    },
    get_barns_data: async function () {
      this.loading = true;
      await AWSAPI.getBarns(this.userData['farmer']['farmer_id'])
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.barnsData = res['data']['data'];
          }
        });
    },
    get_cows_data: async function () {
      this.loading = true;
      this.getCowsData({}, 0, true, true, "");
    },
    getCowsData: async function (
      start_key, cow_sort, cow_sort_forward, cow_in_barn, cow_number
    ) {
      if (this.farmer_id === "") {
        return
      }
      // フィルタ適用
      let cow_pregnancy_status = []
      let cow_status = []
      let cow_sex = []
      let cow_sex_not_exists = true
      let cow_status_not_exists = true
      let cow_breed = []
      let cow_breed_not_exists = false
      // 初回呼び出しかどうか
      await AWSAPI.getSortCows(
        this.farmer_id,
        start_key,
        cow_sort,
        cow_sort_forward,
        cow_pregnancy_status,
        cow_status,
        cow_sex_not_exists,
        cow_sex,
        cow_status_not_exists,
        cow_breed,
        cow_breed_not_exists,
        cow_in_barn,
        cow_number
      )
        .then((res) => {
          if (this.checkAnswer(res, false)) {
            this.cowsData = res.data.data;
            this.loading = false
          }
        });
    },
    alertsDataFiltering() {
      this.saveFilterParams();
      this.alertsTable = [];
      this.select_alert = [];
      let targetDate = dayjs(this.target_date).format('YYYY-MM-DD');
      for (let idx = 0; idx < this.orgAlertsTable.length; idx++) {
        let tempFilterFlg =
          (this.filter_baloon && this.orgAlertsTable[idx]['alert_type'] == 0) ||
          (this.filter_leg && this.orgAlertsTable[idx]['alert_type'] == 2) ||
          (this.filter_tail && this.orgAlertsTable[idx]['alert_type'] == 3) ||
          (this.filter_move && this.orgAlertsTable[idx]['alert_type'] == 4) ||
          (this.filter_kicking && this.orgAlertsTable[idx]['alert_type'] == 5) ||
          (this.filter_feed && this.orgAlertsTable[idx]['alert_type'] == 6) ||
          (this.filter_pose && this.orgAlertsTable[idx]['alert_type'] == 7) ||
          (this.filter_spin && this.orgAlertsTable[idx]['alert_type'] == 8) ||
          (this.filter_calfMove && this.orgAlertsTable[idx]['alert_type'] == 101) ||
          (this.filter_calfBirth && this.orgAlertsTable[idx]['alert_type'] == 102) ||
          (this.filter_calfForemilk && this.orgAlertsTable[idx]['alert_type'] == 100);
        let tempFilterStatusFlg =
          (this.filter_notaction && !this.orgAlertsTable[idx]['is_action'] && !this.orgAlertsTable[idx]['is_wrong_detect']) ||
          (this.filter_action && this.orgAlertsTable[idx]['is_action'] && !this.orgAlertsTable[idx]['is_wrong_detect']) ||
          (this.filter_wrongdetect && this.orgAlertsTable[idx]['is_wrong_detect']);
        let tempFilterLockFlg =
          (this.filter_protection && this.orgAlertsTable[idx]['is_lock']);
        let tempNonFilterFlg = !(
          this.filter_baloon || this.filter_leg || this.filter_tail || this.filter_spin ||
          this.filter_move || this.filter_kicking || this.filter_feed || this.filter_pose ||
          this.filter_calfMove || this.filter_calfBirth || this.filter_calfForemilk
        );
        let tempNonFilterStatusFlg = !(
          this.filter_notaction || this.filter_action || this.filter_wrongdetect
        );
        let tempNonFilterLockFlg = !(
          this.filter_protection
        );
        if ((tempFilterFlg || tempNonFilterFlg) &&
          (tempFilterStatusFlg || tempNonFilterStatusFlg) &&
          (tempFilterLockFlg || tempNonFilterLockFlg) &&
          (this.orgAlertsTable[idx]['date_time'].slice(0, 10) === targetDate)
        ) {
          this.alertsTable.push(this.orgAlertsTable[idx]);
        }
      }
    },
    restore_param() {
      // パラメータ復元
      this.isAdmin = this.$store.state.userAdmin;
      this.filterParams = this.$store.state.filterParams;
    },
    // ===== 以降固定 ====
    get_current_user: async function () {
      // ログイン済みユーザー取得.
      this.loading = true;
      // WebAPI呼び出し.
      await AWSAPI.getUserSp3()
        .then((res) => {
          if (this.checkAnswer(res, true)) {
            this.userData = res['data']['data'][0];
          }
        });
    },
    get_id_token: async function () {
      try {
        const currentUser = await getCurrentUser();
        this.idToken = currentUser.idToken.jwtToken;
      } catch (e) {
        this.alertMessage("通知", ConstParam.relogin_message);
        this.$router.push('/login')
      }
    },
    viewMessage(message, status) {
      if (message === '') { return }
      if (status !== "error") {
        ElMessage({
          message: message,
          type: status,
        });
      } else {
        ElMessage.error(message);
      }
    },
    checkAnswer(answer, autoLogout) {
      let message = "";
      try {
        const statusCode = answer.status;
        if (statusCode == 200) {
          // 正常応答
          if ("authToken" in answer) {
            this.idToken = answer.authToken;
            this.$cookies.set('Authorization', this.idToken);
          }
          return true;
        } else if (statusCode == 403) {
          // 共通鍵更新
          this.getCommonKey(this.publicKey_base64);
          return false;
        } else if (statusCode == 400 && answer.message.name === 'AxiosError') {
          // ユーザー削除のためログオフ
          this.loading = false;
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data &&
            answer.message.response.data.message === "User Not Found"
          ) {
            message = ConstParam.user_error_message;
          } else {
            if (
              "response" in answer.message &&
              "data" in answer.message.response &&
              "message" in answer.message.response.data
            ) {
              this.viewMessage(answer.message.response.data.message, "error");
            }
            return false;
          }
        } else if ((statusCode == 400 && 'message' in answer && answer.message.message === 'need login') ||
          (statusCode == 400 && 'message' in answer && answer.message.message === 'Refresh Token has expired') ||
          (statusCode == 400 && answer.message.message === "Network Error") || autoLogout) {
          // Token期限切れのため再ログイン
          this.loading = false;
          message = ConstParam.relogin_message;
        } else {
          // レスポンスのエラーメッセージの表示
          if (
            "response" in answer.message &&
            "data" in answer.message.response &&
            "message" in answer.message.response.data
          ) {
            this.viewMessage(answer.message.response.data.message, "error");
          }
          return false;
        }
      } catch (e) {
        if (autoLogout) {
          // 自動ログアウト指定
          message = ConstParam.unknown_error_message
        } else {
          return false;
        }
      }
      if (!this.logOut) {
        // 多重処理防止のため
        this.logOut = true
        // ログオフ理由メッセージ通知
        if (this.message !== "") {
          this.alertMessage("通知", message);
        }
        this.click_user_signout();
      }
      return false;
    },
    alertMessage(title, message) {
      this.$alert(message, title, {
        confirmButtonText: 'OK'
      }).catch(() => {
        return
      });
    },
    click_user_signout: async function () {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser) {
          await signout();
        }
      } catch (e) {
        console.log("log out.");
      }
      this.$router.push('/login')
    },
    getAuthLevel(userData) {
      let ret = 0
      if ('user_type' in userData && userData.user_type) {
        ret = userData.user_type
      }
      return ret
    },
    getIsAdmin(authLevel) {
      let ret = true
      if (authLevel != 0) {
        ret = false
      }
      return ret
    }
    // ==================
  },
  watch: {
    actAlertNextFlg: function () {
      if (this.actAlertNextFlg) {
        // 誕生した子牛の自動登録
        this.$confirm("子牛誕生に伴って、出産日登録と\n子牛の仮登録を実施します。\nよろしいですか？", {
          confirmButtonText: 'はい',
          cancelButtonText: 'いいえ',
          type: 'warning'
        }).then(() => {
          this.addBirthCalf()
        }).catch(() => {
          this.loading = false
          return
        });
      }
    },
    userType: function () {
      this.checkUserType()
    },
    barnReportData: function () {
      if (this.barnReportData.length == 0) { return }
      // 日付単位のレポートデータ取得
      this.reportInfo = []
      if ('farmer' in this.userData && 'barns' in this.userData.farmer) {
        let tempBarns = structuredClone(this.barnReportData)
        let isCow = false
        let isYoungCow = true
        if ('cow' in tempBarns) {
          let tempDict = structuredClone(tempBarns.cow)
          for (let idy = 0; idy < tempDict.length; idy++) {
            if (idy >= cowNameAlias.length) {
              break
            }
            let reportsData = this.getCowReportData(tempDict[idy], isCow)
            let tempCow = {
              cow_track_id: tempDict[idy].cow_track_id,
              cow_name: cowNamePrefix + cowNameAlias.substring(idy, idy + 1),
              reports: reportsData,
              move_length: this.cowMoveMax,
              posture_change: this.cowPostureMax,
              spin_around: this.cowSpinMax,
              is_young_cow: false,
            }
            this.reportInfo.push(tempCow)
          }
        }
        if ('young_cow' in tempBarns) {
          let tempDict = structuredClone(tempBarns.young_cow)
          for (let idy = 0; idy < tempDict.length; idy++) {
            if (idy >= cowNameAlias.length) {
              break
            }
            let reportsData = this.getCowReportData(tempDict[idy], isYoungCow)
            let tempCow = {
              cow_track_id: tempDict[idy].cow_track_id,
              cow_name: youngCowNamePrefix + cowNameAlias.substring(idy, idy + 1),
              reports: reportsData,
              move_length: this.cowMoveMax,
              breast_feeding_freq: this.youngCowBreastFeedingMax,
              is_young_cow: true,
            }
            this.reportInfo.push(tempCow)
          }
        }
        this.selectReportIndex = 0
        this.select_cow_track_id = ""
        if (this.reportInfo.length > 0) {
          this.select_cow_track_id = this.reportInfo[this.selectReportIndex].cow_track_id
        }
        this.loading = false
      }
      if (this.daysChangeFlg) {
        let reportIndex = this.reportInfo.findIndex(report => report.cow_track_id === this.saveCowTrackId)
        if (reportIndex != -1) {
          this.selectReportIndex = reportIndex
          this.daysChangeFlg = false
          this.select_cow_track_id = this.saveCowTrackId
          this.reportsAllData = structuredClone(this.reportInfo[this.selectReportIndex].reports)
        }
      } else {
        // 牛房変更
        if (this.reportInfo.length > 0) {
          this.saveCowTrackId = this.select_cow_track_id
          this.reportsAllData = structuredClone(this.reportInfo[this.selectReportIndex].reports)
        }
      }
    },
    reportsAllData: function () {
      let tempMove = []
      let tempPosture = []
      let tempSpin = []
      let tempBff = []
      // 複数頭対応
      if (!this.isCalfReport) {
        if (!(this.cowMoveMax == null)) { tempMove.push(this.cowMoveMax) } else { tempMove.push(0) }
        if (!(this.cowPostureMax == null)) { tempPosture.push(this.cowPostureMax) } else { tempPosture.push(0) }
        if (!(this.cowSpinMax == null)) { tempSpin.push(this.cowSpinMax) } else { tempSpin.push(0) }
      } else {
        if (!(this.cowMoveMax == null)) { tempMove.push(this.cowMoveMax) } else { tempMove.push(0) }
        if (!(this.youngCowBreastfeedingMax == null)) { tempBff.push(this.youngCowBreastfeedingMax) } else { tempBff.push(0) }
      }
      for (let idx = 0; idx < this.reportsAllData.length; idx++) {
        if (!(this.reportsAllData[idx]['move_length'] == null)) {
          tempMove.push(this.reportsAllData[idx]['move_length'])
        }
        if (!this.isCalfReport) {
          if (!(this.reportsAllData[idx]['posture_change'] == null)) {
            tempPosture.push(this.reportsAllData[idx]['posture_change'])
          }
          if (!(this.reportsAllData[idx]['spin_around'] == null)) {
            tempSpin.push(this.reportsAllData[idx]['spin_around'])
          }
        } else {
          if (!(this.reportsAllData[idx]['breast_feeding_freq'] == null)) {
            tempBff.push(this.reportsAllData[idx]['breast_feeding_freq'])
          }
        }
      }
      if (tempMove.length > 0 && !isNaN(Math.ceil(tempMove.reduce(aryMax)))) {
        this.moveMax = Math.ceil(tempMove.reduce(aryMax))
      } else {
        this.moveMax = 1
      }
      if (tempPosture.length > 0 && !isNaN(tempPosture.reduce(aryMax))) {
        this.postureMax = tempPosture.reduce(aryMax)
      } else {
        this.postureMax = 1
      }
      if (tempSpin.length > 0 && !isNaN(tempSpin.reduce(aryMax))) {
        this.spinMax = tempSpin.reduce(aryMax)
      } else {
        this.spinMax = 1
      }
      if (tempBff.length > 0 && !isNaN(tempBff.reduce(aryMax))) {
        this.youngCowBreastfeedingMax = tempBff.reduce(aryMax)
      } else {
        this.youngCowBreastfeedingMax = 1
      }
      if (this.eventMenuRadio === "グラフ") {
        // レポート描画
        this.drawReport()
      }
      this.loading = false
    },
    report_days: function () {
      this.barnReportData = []
    },
    alertsData: function () {
      this.alertsTable = [];
      this.select_alert = [];
      for (let idx = 0; idx < this.alertsData.length; idx++) {
        let thumbnailPath = "";
        let imagePath = "";
        let imageType = "jpg";
        let alertType = this.alertsData[idx]['alert_type'];
        if ("thumbnail_path" in this.alertsData[idx] && this.alertsData[idx]['thumbnail_path'] !== "") {
          thumbnailPath = this.alertsData[idx]['thumbnail_path'];
          imagePath = thumbnailPath.replaceAll('_tmb', '');
        }
        if (imagePath === "") {
          imageType = "png";
          if (alertType == 4) {
            // 歩数
            imageType = "step";
          } else if (alertType == 6) {
            // 捕食
            imageType = "eat";
          } else if (alertType == 7) {
            // 姿勢
            imageType = "stance";
          } else if (alertType == 8) {
            // 旋回
            imageType = "spin";
          } else if (alertType == 100) {
            // 初乳
            imageType = "foremilk";
          } else if (alertType == 101) {
            // 子牛移動量低下
            imageType = "calf";
          } else {
            imageType = "no";
          }
        }
        let tempData = {
          "event": this.alertsData[idx]['event'],
          "date_time": this.alertsData[idx]['date_time'],
          "alert_type": alertType,
          "is_action": this.alertsData[idx]['is_action'],
          "is_lock": this.alertsData[idx]['is_lock'],
          "is_read": this.alertsData[idx]['is_read'],
          "is_wrong_detect": this.alertsData[idx]['is_wrong_detect'],
          "message": this.getAlertMessage(alertType),
          "datetime": dayjs(this.alertsData[idx].date_time).format('HH:mm'),
          "imagePath": thumbnailPath,
          "imageType": imageType,
          "fullSizeImagePath": imagePath,
          "view_date_time": dayjs(this.alertsData[idx].date_time).format('YYYY/MM/DD(ddd) HH:mm')
        }
        this.alertsTable.push(tempData);
      }
      this.orgAlertsTable = this.alertsTable;
      if (this.eventMenuRadio === "一覧") {
        // アラートカレンダーコントロール
        this.setAlertDates();
      }
      if (this.edit_alert) {
        // アラート編集中なら表示対象日付を設定
        this.report_view_date = this.alert_edit_date;
        this.target_date = this.alert_edit_date.substring(0, 10).replaceAll('/', '-');
      }
      this.alertsDataFiltering();
      this.set_cow_name();
    },
    barnsData: function () {
      // 牛情報取得
      this.barnsInfoDataSet();
      // アラートデータ取得
      this.get_alerts_data();
    },
    cowsData: function () {
      // 牛一覧情報作成
      let tempTable = [];
      for (let idx = 0; idx < this.cowsData.length; idx++) {
        let tempBarn = "";
        for (let idy = 0; idy < this.barnsData.length; idy++) {
          if ("cow_id" in this.barnsData[idy] && "cow_id" in this.cowsData[idx]) {
            if (this.barnsData[idy]['cow_id'].indexOf(this.cowsData[idx]['cow_id']) != -1) {
              tempBarn = this.barnsData[idy]['barn_name'];
              break;
            }
          }
        }
        let tempBreed = this.cow_kinds.length - 1;
        if ("cow_breed" in this.cowsData[idx]) {
          tempBreed = this.cowsData[idx]['cow_breed'];
        }
        let tempData = {
          "id": this.cowsData[idx]['cow_id'],
          "no": this.cowsData[idx]['cow_number'],
          "name": this.cowsData[idx]['cow_name'],
          "breed": this.cow_kinds[tempBreed],
          "birthdate": this.cowsData[idx]['last_birth']['birth_reserve_date'],
          "fertilizationdate": this.cowsData[idx]['last_birth']['inseminate_on'],
          "lastestruson": this.cowsData[idx]['last_birth']['estrus_on'],
          "lastbirthon": this.cowsData[idx]['last_birth']['birth_on'],
          "barn": tempBarn,
          "status": this.cowsData[idx]['cow_status'],
          "pregnancystatus": this.cowsData[idx]['cow_pregnancy_status']
        }
        tempTable.push(tempData);
      }
      this.tableData = structuredClone(tempTable);
      this.orgTableData = structuredClone(tempTable);
      // カレンダーメインの修正対応
      if ('farmer' in this.userData && 'barns' in this.userData.farmer) {
        this.barnsData = structuredClone(this.userData.farmer.barns)
      }
    },
    // ===== 以降固定 ====
    userData: function () {
      if ('user_name' in this.userData) {
        this.viewUserName = this.userData.user_name;
      }
      if ('farmer' in this.userData && 'farmer_name' in this.userData.farmer) {
        this.viewFarmerName = this.userData.farmer.farmer_name;
      }
      if ('farmer' in this.userData && 'farmer_id' in this.userData.farmer) {
        this.farmer_id = this.userData.farmer.farmer_id;
      }
      let tempUserType = this.getAuthLevel(this.userData)
      this.isAdmin = this.getIsAdmin(tempUserType)
      this.userType = tempUserType
      // パラメータ保存(権限)
      this.$store.commit('setUserAdmin', this.isAdmin);
      // 牛情報取得
      this.get_cows_data();
    }
    // ==================
  }
}
</script>

<style scoped>
.toggle-area .el-radio-group {
  border: solid 1px#ffdf5e;
  border-radius: 12px;
}

.toggle-area .el-radio-button,
.toggle-area :deep(.el-radio-button__inner) {
  width: 191px;
  height: 44px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  border: none;
  border-radius: 12px !important;
}

.event-table .el-row,
.event-table td,
.event-table :deep(.el-table__cell) {
  padding: 0;
  border: none;
}

.el-dialog__body {
  padding: 0px !important;
}

.el-row {
  justify-content: left;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}

.filter_left {
  margin-left: 28px;
  font-size: 14px;
}

.filter_left_checkbox {
  margin-left: 20px;
  font-size: 14px;
}

.alertDate {
  width: 250px;
  height: 260px;
}

.img-size {
  width: 214px;
  height: 120px;
}

.el-message-box__content {
  white-space: pre-line !important;
}
</style>